import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMobileAlt} from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import lineFooter from "../assets/img/footer-topbg.png";
import logoVitrine from "../assets/img/logo-vitrine.png";
import logoSupport from "../assets/img/ministere-culture.png";

function Footer() {
  return (
    <Container fluid className='p-0'>
      <span className="spacing-50"></span>

      <Row className="footer-header">
        <Col xs={12} className='p-0'>
          <img src={lineFooter} className="footer-line" style={{width: '100.1%'}}/>
        </Col>
      </Row>
      <Row className="footer py-5">
          <Col xs={12} md={6} className="m6">
            <Row className="valign-wrapper">
              <Col xs={4}>
                <img src={logoVitrine} className="full-width" />
              </Col>
              <Col xs={8} >
                <ul className="brand-info-list">
                  <li>
                    <a href="mailto:contactlavitrine.re@gmail.com">
                        <span className="btn-floating dark"><FontAwesomeIcon icon={faEnvelope} /> </span> contactlavitrine.re@gmail.com
                    </a>
                  </li>
                  <li>
                    <a href="callto:+262692 612728">
                      <span className="btn-floating dark"><FontAwesomeIcon icon={faMobileAlt} /></span> 0692 61 27 28
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/tropicaldrawingfestival" target="_blank">
                      <span className="btn-floating dark"><FontAwesomeIcon icon={faFacebookF} /></span> @tropicaldrawing
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/la_vitrine.re" target="_blank">
                      <span className="btn-floating dark"><FontAwesomeIcon icon={faInstagram} /></span> @la_vitrine.re
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={6} className="m6">					
              <Row>
                <Col xs={{span: 6, offset: 3}}>
                  <img src={logoSupport} className="full-width" />
                </Col>
              </Row>						
          </Col>
        </Row>	
    </Container>
  )
}

export default Footer